// extracted by mini-css-extract-plugin
module.exports = {"slot":"header-logo_slot__sSXn0","wordmark":"header-logo_wordmark__DUmx4"};